jQuery(document).ready(function ($) {
    $('[data-articles-load-more]').on('click', function () {
        const $button = $(this);
        const $grid = $button.closest('.articles').find('[data-articles-grid]');

        const next_page = parseInt($button.data('page'), 10) + 1;

        $button.prop('disabled', true);
        show_loading_overlay();

        $.post(blogs.ajax_url, {
            action: 'load_more_articles',
            nonce: blogs.nonce,
            page: next_page
        }).done(function (response) {
            if (!response.success) {
                return;
            }

            $grid.append(response.data.html);

            $button.data('page', response.data.current_page);

            if (response.data.current_page >= response.data.max_pages) {
                $button.attr('hidden', true);
            }
        }).always(function () {
            $button.prop('disabled', false);
            hide_loading_overlay();
        });
    });
});
